import { render, staticRenderFns } from "./ConsumptionPerformancePage.vue?vue&type=template&id=bdef263e&"
import script from "./ConsumptionPerformancePage.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionPerformancePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports